<template>
    <div>
        <Modal @onConfirm="onConfirm" 
            @onClose="onClose" 
            :isDisabled="confirmDisabled" 
            :isOpen="isOpen" 
            :modalTitle="currentPosition.name" 
            :confirmLabel=false
            :cancelLabel="$t('layouts.global.close')"
            class="send_reports_modal">

            <div class="campaign_block" v-if="currentPosition.is_campaign">
                <notifText>
                    {{ $t('modules.positions.index.positionsList.campaignNotice') }}
                </notifText>
                <div class="campaign_link" >
                    {{currentPosition.campaign_link}}
                </div>
                <div class="campaign_end_date" v-if="currentPosition.campaign_end_date">
                    {{ $t('modules.positions.index.positionsList.campaignEndDate') }} : {{campaignEndDate}}

                </div>
            </div>


        </Modal>
    </div>
</template>

<script>
export default {
    name: 'CampaignLinkModal',
    props: ['opened'],
    components: {},
    data(){
        return {
            isOpen: false,
            confirmDisabled: true,
            isLoading: false
        }
    },
    computed: {
        currentPosition(){
            return this.$store.state.PositionStore.currentPosition
        },
        campaignEndDate(){
            if (this.currentPosition.campaign_end_date){
                return this.currentPosition.campaign_end_date.split("-").reverse().join("-").replace(/-/g, '/')
            }else {
                return "en traitement"
            }
        }
    },
    methods: {
        onConfirm(){

        },
        onClose(){
            this.isOpen = false
            this.$emit('closeCampaignLink')
            this.confirmDisabled = true
        }
    },
    watch: {
        'opened': {
            handler: function(newVal, oldVal){
                this.isOpen = newVal
            }
        }
    }
}
</script>

<style lang="scss" >
    .send_reports_modal{
        text-align: left;
        .modal-card{
            width: 100%;
            max-width: 800px;
        }

    }
    .campaign_end_date{
        font-weight: 500;
        margin-top: 20px;
        text-align: center;
        font-size: 1.25rem;
    }
</style>